var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.chargingLinkLoading)?_c('div',{staticClass:"display-message"},[_c('img',{attrs:{"src":"/static/logo-horiz.png","alt":""}}),_vm._v(" "),_c('b',[_vm._v("Carregando Cobrança")])]):_c('charging',{attrs:{"sale":_vm.sale,"chargingLink":_vm.chargingLink}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcc77504","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 827
// module chunks = 0